export default "__VITE_ASSET__FLS$A7LS__"